import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { storage } from '@utils/index'

import elementEnLocale from 'element-ui/lib/locale/lang/en.js' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN.js'// element-ui lang
import elementTWLocale from 'element-ui/lib/locale/lang/zh-TW.js'// element-ui lang

import enLocale from '@/lang/en-US/index.js'
import zhLocale from '@/lang/zh-CN/index.js'
import twLocale from '@/lang/zh-TW/index.js'

Vue.use(VueI18n)

const messages = {
  'en-US': {
    ...enLocale,
    ...elementEnLocale
  },
  'zh-CN': {
    ...zhLocale,
    ...elementZhLocale
  },
  'zh-TW': {
    ...twLocale,
    ...elementTWLocale
  }
}

export function getLanguage(): string {
  const chooseLanguage = storage.get('language') as string
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  // eslint-disable-next-line
  const language = (navigator.language || (navigator as any).browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'zh-CN'
}

const i18n = new VueI18n({
  // set locale
  locale: getLanguage(),
  // set locale messages
  messages
})

// eslint-disable-next-line
export function $t(this: any, key: string): string {
  // eslint-disable-next-line
  return (i18n as any)._t(key, i18n.locale, (i18n as any)._getMessages(), this)
}

// eslint-disable-next-line
export function $te(this: any, key: string): boolean {
  // eslint-disable-next-line
  return (i18n as any)._te(key, i18n.locale, (i18n as any)._getMessages(), this)
}

export default i18n
